import ParentsLayout from "@/layout/parents";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const PassportPage = lazy(
  () => import("@/features/student-view/passport/pages/student-passport")
);
const SendEmailToMentorPage = lazy(
  () => import("@/features/parents-view/send-email/pages/send-email-to-mentor")
);

const TestResultsPage = lazy(
  () => import("@/shared/testResults/pages/test-results-page")
);

export const parentsRoutes: RouteObject[] = [
  {
    path: "/parents",
    element: <ParentsLayout />,
    children: [
      {
        path: "/parents/passport",
        element: <PassportPage isAdmin={false} isParent={true} />,
      },
      {
        path: "/parents/send-email",
        element: <SendEmailToMentorPage />,
      },
      {
        path: "/parents/test-results/:studentId/:schoolYear",
        element: <TestResultsPage />,
      },
    ],
  },
];
